import styled from 'styled-components';
import { sizes } from 'style';

export const StyledHero = styled.div`
  position: relative;
  min-height: 580px;
  height: 85vh;

  @media ${sizes.mobileMedium} {
    min-height: 680px;
  }

  @media ${sizes.mobileLarge} {
    height: 92vh;
  }

  @media ${sizes.desktop} {
    min-height: 740px;
    height: 100vh;
  }
`;
